import React from 'react';
import { Navigate } from 'react-router-dom';

const ManagerRoute = ({ children }) => {
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;

  if (!user || (user.role !== 'MANAGER' && user.role !== 'BOSS')) {
    return <Navigate to="/admin/orders" replace />;
  }

  return children;
};

export default ManagerRoute;
